import { ConferencingType } from "@clockwise/schema";
import { isEmpty, isUndefined } from "lodash";
import React, { useCallback } from "react";
import toast from "react-hot-toast";
import { Async } from "../atoms/Async";
import { EventElementsWrap } from "../atoms/EventElementsWrap";
import { JoinVideoConfAction } from "../atoms/JoinVideoConfAction";
import { SelectVideoConf } from "../atoms/SelectVideoConf";
import { SelectVideoConfAction } from "../atoms/SelectVideoConfAction";

const _openVideoLink = (url: string) => {
  window.open(url, "_blank");
};

const notifyJoinError = () => toast.error("Unable to open video link");

type Props = {
  enabledTypes: ConferencingType[];
  onSelect: (type?: ConferencingType) => void;
  openVideoLink?: (url: string) => void;
  readonly?: boolean;
  selected?: ConferencingType;
  videoLink?: string;
  loading?: boolean;
  showChanges?: boolean;
};

export const ECVideoConf = ({
  enabledTypes,
  readonly = false,
  onSelect,
  openVideoLink = _openVideoLink,
  selected,
  videoLink,
  loading = false,
  showChanges,
}: Props) => {
  const handleJoin = useCallback(
    () =>
      isUndefined(videoLink) || isEmpty(videoLink) ? notifyJoinError() : openVideoLink(videoLink),
    [openVideoLink, videoLink],
  );

  const handleRemove = useCallback(() => onSelect(undefined), [onSelect]);

  let body = null;

  if (selected) {
    if (readonly && videoLink) {
      body = <JoinVideoConfAction onJoin={handleJoin} selected={selected} />;
    } else {
      body = (
        <SelectVideoConfAction
          disabled={readonly}
          videoLink={videoLink}
          onJoin={handleJoin}
          onRemove={handleRemove}
          selected={selected}
        />
      );
    }
  } else {
    body = (
      <Async loading={loading} loadingHeight="28px" loadingWidth="100px">
        <SelectVideoConf
          disabled={readonly}
          enabledTypes={enabledTypes}
          onSelect={onSelect}
          selected={selected}
        />
      </Async>
    );
  }

  return (
    <EventElementsWrap name="video" showChanges={showChanges}>
      {body}
    </EventElementsWrap>
  );
};
